import * as React from "react";
import { Route } from "react-router-dom";

import Redirect from "components/Redirect";
import { BrowserHistory } from "services/browser-history";

/**
 * HOC that remembers previously visited URL after component is unmounted.
 * It is useful for creating top-level sections that will keep its previous route
 * when user navigates out of it and then comes back.
 *
 * This HOC must be a child of react-router's <Router> compoment.
 *
 * @param WrappedComponent
 * @param sectionPath For example: /tickets, /archives, /reports
 */
export function withRememberLastRoute<P>(
  WrappedComponent: React.ComponentType<P>,
  sectionPath: string
): React.ComponentType<P> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let previousRoute: any = null;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let shouldRedirect: any = null;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line react/display-name
  return class extends React.Component<P> {
    constructor(props: P) {
      super(props);
      const previousLocation = BrowserHistory.browserHistoryObject.location;
      // redirect to previous section only when agent visits main section path
      // (for example: /tickets, but not /tickets/TICKET_ID)
      shouldRedirect = previousLocation.pathname === sectionPath;
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    render() {
      if (shouldRedirect) {
        shouldRedirect = false;
        if (previousRoute) {
          return <Redirect to={previousRoute} />;
        }
      }

      return (
        <>
          <Route
            path={`${sectionPath}/:anything?`}
            render={({ location }) => {
              previousRoute = `${location.pathname}`;
              return null;
            }}
          />
          <WrappedComponent {...this.props} />
        </>
      );
    }
  };
}
